import { render } from "./MFITTSeatGuide.vue?vue&type=template&id=07e5681e"
import script from "./MFITTSeatGuide.vue?vue&type=script&lang=js"
export * from "./MFITTSeatGuide.vue?vue&type=script&lang=js"

import "./MFITTSeatGuide.vue?vue&type=style&index=0&id=07e5681e&lang=scss"
script.render = render

export default script